import Icon from '../../components/Icon.vue'

Icon.register({"regular/clock":{"width":512,"height":512,"paths":[{"d":"M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM256 456C145.5 456 56 366.5 56 256S145.5 56 256 56 456 145.5 456 256 366.5 456 256 456zM317.8 351.6L232.9 289.9C229.8 287.6 228 284 228 280.2V116C228 109.4 233.4 104 240 104H272C278.6 104 284 109.4 284 116V257.7L350.8 306.3C356.2 310.2 357.3 317.7 353.4 323.1L334.6 349C330.7 354.3 323.2 355.5 317.8 351.6z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/clock.js
// module id = SfFL
// module chunks = 0